var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem",value:([_vm.type, _vm.size ].concat( _vm.modifiers)),expression:"[type, size, ...modifiers]"}]})}
var staticRenderFns = []

export { render, staticRenderFns }